import React, { useCallback, useEffect, useState } from 'react';
import {
	AppBar,
	Toolbar,
	TextField,
	Tab,
	Tabs,
	withStyles,
	styled,
	Grid,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	IconButton,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SvgIcon from '@material-ui/core/SvgIcon';
import InputAdornment from '@material-ui/core/InputAdornment';
import Loading from '../../components/Loading';
import { debounce } from 'lodash'
const SkillsList = ({
	data,
	fetch,
	dataPeriodo,
	dataComponente,
	dataMetodologia,
	fetchPeriodo,
	fetchComponente,
	fetchMetodologia,
	tabValue = 'habilidade',
	handleTabValue,
	isLoading = false,
	className
}) => {
	const [selectedTab, setSelectedTab] = useState(tabValue);

	let searchTimer;

	const handleTabChange = (event, newValue) => {
		setSelectedTab(newValue);
		handleTabValue(newValue);
	};

	const StyledTabs = withStyles({
		root: {
			width: '100%',
			borderBottom: '1px solid #e0e0e0',
		},
		indicator: {
			backgroundColor: 'transparent',
		},
	})(Tabs);

	const StyledTab = withStyles({
		root: {
			textTransform: 'none',
			width: '23%',
			fontSize: '16px',
			fontWeight: '600',
			fontFamily: 'Public Sans',
			color: '#727780',
			marginRight: '20px',
		},
		selected: {
			color: '#1976D2',
			borderBottom: '2px solid #1976D2',
		},
	})((props) => <Tab {...props} style={{ fontSize: '20px' }} />);

	const StyledTextField = styled(TextField)({
		marginTop: '1rem',
	});

	const handleSetState = debounce((value) => {
		fetch(value);
	}, 2000);

	const handleSetStatePeriodo = debounce((value) => {
		fetchPeriodo(value);
	}, 2000);

	const handleSetStateMetodologia = debounce((value) => {
		fetchMetodologia(value);
	}, 2000);


	return (
		<div>
			<Grid container>
				<Grid item xs={12}>
					<label
						style={{ fontFamily: 'Public Sans', fontWeight: '600', fontSize: '18px', color: '#262930', marginTop: '36px', marginBottom: '16px' }}
					>
						Ranking de Planos de Aprendizagem gerados
					</label>
				</Grid>
				<Grid item xs={12}>
					<AppBar
						position="static"
						style={{
							backgroundColor: 'transparent',
							boxShadow: 'none',
							width: '100%',
						}}
					>
						<Toolbar style={{ marginBottom: '24px', fontSize: '16px', fontWeight: '600', fontFamily: 'Public Sans', }}>
							<StyledTabs
								value={selectedTab}
								onChange={handleTabChange}
								aria-label="Tabs"

							>
								<StyledTab label="Ano/Série Escolar" value="ano/serie" />
								<StyledTab label="Habilidade | Competência" value="habilidade" />
								{/* <StyledTab
									label={<div style={{ textAlign: 'center' }}>Área de Conhecimento | Componente Curricular</div>}
									value="componente curricular"
								/> */}
								<StyledTab label="Metodologia de Ensino" value="metodologia" />
							</StyledTabs>
						</Toolbar>
					</AppBar>
				</Grid>
				<Grid item xs={12} style={{ border: 'solid 2px #E5E7EB', borderRadius: '10px', padding: '10px' }}>
					<Grid item xs={12}>
						{selectedTab === 'habilidade' && (

							<div>
								<Grid item xs={12} style={{ borderBottom: '2px solid #E5E7EB' }}>
									<p style={{ fontSize: '16px', fontFamily: 'Public Sans', color: '#727780', fontWeight: '600', padding: '8px', marginBottom: '6px' }}>Código da habilidade</p>
								</Grid>
								<Grid
									item
									xs={12}
									style={{
										borderRadius: '10px',
										marginBottom: '12px',
									}}
								>
									<Grid container alignItems="center">
										<Grid item xs={12}>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													alignItems: 'flex-start',
												}}
											>
												{/* <StyledTextField
													style={{ width: '100%' }}
													label="Pesquisar por habilidade"
													variant="outlined"
													onChange={(e) => handleSetState(e.target.value.toUpperCase())}
													InputProps={{
														startAdornment: (
															<InputAdornment position="start">
																<SvgIcon
																	width="24"
																	height="24"
																	viewBox="0 0 24 24"
																	fill="none"
																	xmlns="http://www.w3.org/2000/svg"
																	style={{ cursor: 'pointer' }}
																>
																	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																		<g clip-path="url(#clip0_695_46806)">
																			<path d="M10.9922 19.9922C9.75781 19.9922 8.59375 19.7578 7.5 19.2891C6.40625 18.8203 5.45312 18.1797 4.64062 17.3672C3.82812 16.5547 3.1875 15.6016 2.71875 14.5078C2.23438 13.4141 1.99219 12.2422 1.99219 10.9922C1.99219 9.75781 2.23438 8.59375 2.71875 7.5C3.1875 6.40625 3.82812 5.45312 4.64062 4.64062C5.45312 3.82813 6.40625 3.1875 7.5 2.71875C8.59375 2.23438 9.75781 1.99219 10.9922 1.99219C12.2422 1.99219 13.4141 2.23438 14.5078 2.71875C15.6016 3.1875 16.5547 3.82813 17.3672 4.64062C18.1797 5.45312 18.8203 6.40625 19.2891 7.5C19.7578 8.59375 19.9922 9.75781 19.9922 10.9922C19.9922 11.9141 19.8594 12.8047 19.5938 13.6641C19.3281 14.5078 18.9609 15.2812 18.4922 15.9844L21.4922 19.0078C21.8359 19.3516 22.0078 19.7656 22.0078 20.25C22.0078 20.7344 21.8359 21.1484 21.4922 21.4922C21.1484 21.8359 20.7344 22.0078 20.25 22.0078C19.7656 22.0078 19.3516 21.8359 19.0078 21.4922L15.9844 18.4922C15.2812 18.9609 14.5 19.3281 13.6406 19.5938C12.7969 19.8594 11.9141 19.9922 10.9922 19.9922ZM10.9922 18C11.9609 18 12.875 17.8203 13.7344 17.4609C14.5781 17.0859 15.3125 16.5859 15.9375 15.9609C16.5781 15.3203 17.0859 14.5781 17.4609 13.7344C17.8203 12.875 18 11.9609 18 10.9922C18 10.0234 17.8203 9.11719 17.4609 8.27344C17.0859 7.42969 16.5781 6.69531 15.9375 6.07031C15.3125 5.42969 14.5781 4.92188 13.7344 4.54688C12.875 4.1875 11.9609 4.00781 10.9922 4.00781C10.0234 4.00781 9.11719 4.1875 8.27344 4.54688C7.42969 4.92188 6.6875 5.42969 6.04688 6.07031C5.42188 6.69531 4.92188 7.42969 4.54688 8.27344C4.1875 9.11719 4.00781 10.0234 4.00781 10.9922C4.00781 11.9609 4.1875 12.875 4.54688 13.7344C4.92188 14.5781 5.42188 15.3203 6.04688 15.9609C6.6875 16.5859 7.42969 17.0859 8.27344 17.4609C9.11719 17.8203 10.0234 18 10.9922 18ZM10.9922 6C10.7266 6 10.4922 6.10156 10.2891 6.30469C10.1016 6.49219 10.0078 6.72656 10.0078 7.00781C10.0078 7.27344 10.1016 7.50781 10.2891 7.71094C10.4922 7.89844 10.7266 7.99219 10.9922 7.99219C11.8203 7.99219 12.5234 8.28906 13.1016 8.88281C13.6953 9.46094 13.9922 10.1641 13.9922 10.9922C13.9922 11.2734 14.0859 11.5156 14.2734 11.7188C14.4766 11.9062 14.7188 12 15 12C15.2812 12 15.5156 11.9062 15.7031 11.7188C15.9062 11.5156 16.0078 11.2734 16.0078 10.9922C16.0078 10.3047 15.875 9.65625 15.6094 9.04688C15.3438 8.4375 14.9844 7.91406 14.5312 7.47656C14.0781 7.02344 13.5469 6.66406 12.9375 6.39844C12.3438 6.13281 11.6953 6 10.9922 6Z" fill="#ABB0BA" />
																		</g>
																		<defs>
																			<clipPath id="clip0_695_46806">
																				<rect width="24" height="24" fill="white" />
																			</clipPath>
																		</defs>
																	</svg>

																</SvgIcon>
															</InputAdornment>
														),
													}}
												/> */}
												Pesquisar por habilidade:
												<input
													onChange={
														(e) => handleSetState(e.target.value.toUpperCase())
													}
													style={{ width: '100%' }}
													type='text'
												/>
											</div>
										</Grid>
									</Grid>
								</Grid>
								{!isLoading ? (
									<>
										{data && data.slice(0, 6).map((skill) => (
											<Accordion key={skill.habilidade_id} style={{ boxShadow: 'none', marginBottom: '8px', border: 'none' }}>
												<AccordionSummary className={className} style={{ backgroundColor: '#F7F8FC' }}>
													<div style={{ flexWrap: 'wrap', paddingLeft: '30px' }}>
														<h2
															style={{
																marginLeft: '20px',
																fontSize: '14px',
																fontFamily: 'Public Sans',
																fontWeight: '500',
																color: '#4A4F58'
															}}
														>
															{skill.habilidade_codigo}
														</h2>

														<h6
															style={{
																marginLeft: '20px',
																fontSize: '14px',
																fontFamily: 'Public Sans',
																fontWeight: '400',
																color: '#727780'
															}}
														>
															{skill.habilidade_nome}
														</h6>
														<h6
															style={{
																marginLeft: '20px',
																fontSize: '14px',
																fontFamily: 'Public Sans',
																fontWeight: '400',
																color: '#727780'
															}}
														>
															Competência: Não se aplica
														</h6>
													</div>

													<p
														style={{
															marginLeft: 'auto',

															fontSize: '16px',
															fontFamily: 'Public Sans',
															fontWeight: '600',
															color: '#727780'
														}}
													>
														{skill.quantidade_usos}
													</p>

													<IconButton style={{ position: 'relative', right: '97%' }}>
														<ExpandMoreIcon />
													</IconButton>
												</AccordionSummary>

												<AccordionDetails>
													<ul style={{ width: '100%' }} >
														{Object.entries(skill.escolas_utilizaram).map(([escola, vezes]) => (
															<li
																key={escola}
																style={{
																	display: 'flex',
																	justifyContent: 'space-between',
																	alignItems: 'center',
																	color: '#727780',
																	fontFamily: 'Public Sans',
																	fontWeight: '400',
																	fontSize: '16px',
																	borderBottom: '1px solid #ccc',
																	padding: '8px 0',
																	width: '100%'
																}}
															>
																<span style={{ flex: 1, fontFamily: 'Public Sans' }}>{escola}</span>
																<span style={{ flex: 1, textAlign: 'right', fontFamily: 'Public Sans' }}>{vezes}</span>
															</li>
														))}
													</ul>
												</AccordionDetails>
											</Accordion>
										))}
									</>
								) : (
									<Loading />
								)}
							</div>
						)}
						{selectedTab === 'ano/serie' && (
							<div>
								<Grid item xs={12} style={{ borderBottom: '2px solid #E5E7EB', }}>
									<p
										style={{
											fontSize: '16px',
											color: '#727780',
											fontFamily: 'Public Sans',
											fontWeight: '600',
											padding: '8px',
											marginBottom: '6px'

										}}
									>
										Ano/Série Escolar
									</p>
								</Grid>

								<div>
									<Grid item xs={12} style={{ borderRadius: '10px', marginBottom: '12px', }}>
										<Grid container alignItems="center">
											<Grid item xs={12}>
												<div
													style={{
														display: 'flex',
														alignItems: 'flex-start',
														flexDirection: 'column',
													}}
												>
													{/* <StyledTextField
														style={{ width: '100%' }}
														label="Pesquisar ano/serie"
														variant="outlined"
														onChange={(e) => handleSetStatePeriodo(e.target.value)}
														InputProps={{
															startAdornment: (
																<InputAdornment position="start">
																	<SvgIcon
																		width="24"
																		height="24"
																		viewBox="0 0 24 24"
																		fill="none"
																		xmlns="http://www.w3.org/2000/svg"
																		style={{ cursor: 'pointer' }}
																	>
																		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<g clip-path="url(#clip0_695_46806)">
																				<path
																					d="M10.9922 19.9922C9.75781 19.9922 8.59375 19.7578 7.5 19.2891C6.40625 18.8203 5.45312 18.1797 4.64062 17.3672C3.82812 16.5547 3.1875 15.6016 2.71875 14.5078C2.23438 13.4141 1.99219 12.2422 1.99219 10.9922C1.99219 9.75781 2.23438 8.59375 2.71875 7.5C3.1875 6.40625 3.82812 5.45312 4.64062 4.64062C5.45312 3.82813 6.40625 3.1875 7.5 2.71875C8.59375 2.23438 9.75781 1.99219 10.9922 1.99219C12.2422 1.99219 13.4141 2.23438 14.5078 2.71875C15.6016 3.1875 16.5547 3.82813 17.3672 4.64062C18.1797 5.45312 18.8203 6.40625 19.2891 7.5C19.7578 8.59375 19.9922 9.75781 19.9922 10.9922C19.9922 11.9141 19.8594 12.8047 19.5938 13.6641C19.3281 14.5078 18.9609 15.2812 18.4922 15.9844L21.4922 19.0078C21.8359 19.3516 22.0078 19.7656 22.0078 20.25C22.0078 20.7344 21.8359 21.1484 21.4922 21.4922C21.1484 21.8359 20.7344 22.0078 20.25 22.0078C19.7656 22.0078 19.3516 21.8359 19.0078 21.4922L15.9844 18.4922C15.2812 18.9609 14.5 19.3281 13.6406 19.5938C12.7969 19.8594 11.9141 19.9922 10.9922 19.9922ZM10.9922 18C11.9609 18 12.875 17.8203 13.7344 17.4609C14.5781 17.0859 15.3125 16.5859 15.9375 15.9609C16.5781 15.3203 17.0859 14.5781 17.4609 13.7344C17.8203 12.875 18 11.9609 18 10.9922C18 10.0234 17.8203 9.11719 17.4609 8.27344C17.0859 7.42969 16.5781 6.69531 15.9375 6.07031C15.3125 5.42969 14.5781 4.92188 13.7344 4.54688C12.875 4.1875 11.9609 4.00781 10.9922 4.00781C10.0234 4.00781 9.11719 4.1875 8.27344 4.54688C7.42969 4.92188 6.6875 5.42969 6.04688 6.07031C5.42188 6.69531 4.92188 7.42969 4.54688 8.27344C4.1875 9.11719 4.00781 10.0234 4.00781 10.9922C4.00781 11.9609 4.1875 12.875 4.54688 13.7344C4.92188 14.5781 5.42188 15.3203 6.04688 15.9609C6.6875 16.5859 7.42969 17.0859 8.27344 17.4609C9.11719 17.8203 10.0234 18 10.9922 18ZM10.9922 6C10.7266 6 10.4922 6.10156 10.2891 6.30469C10.1016 6.49219 10.0078 6.72656 10.0078 7.00781C10.0078 7.27344 10.1016 7.50781 10.2891 7.71094C10.4922 7.89844 10.7266 7.99219 10.9922 7.99219C11.8203 7.99219 12.5234 8.28906 13.1016 8.88281C13.6953 9.46094 13.9922 10.1641 13.9922 10.9922C13.9922 11.2734 14.0859 11.5156 14.2734 11.7188C14.4766 11.9062 14.7188 12 15 12C15.2812 12 15.5156 11.9062 15.7031 11.7188C15.9062 11.5156 16.0078 11.2734 16.0078 10.9922C16.0078 10.3047 15.875 9.65625 15.6094 9.04688C15.3438 8.4375 14.9844 7.91406 14.5312 7.47656C14.0781 7.02344 13.5469 6.66406 12.9375 6.39844C12.3438 6.13281 11.6953 6 10.9922 6Z"
																					fill="#ABB0BA"
																				/>
																			</g>

																			<defs>
																				<clipPath id="clip0_695_46806">
																					<rect width="24" height="24" fill="white" />
																				</clipPath>
																			</defs>
																		</svg>
																	</SvgIcon>
																</InputAdornment>
															),
														}}
													/> */}
													Pesquisar ano/serie:
													<input
														onChange={
															(e) => handleSetStatePeriodo(e.target.value.toUpperCase())
														}
														style={{ width: '100%' }}
														type='text'
													/>
												</div>
											</Grid>
										</Grid>
									</Grid>
								</div>
								{!isLoading ? (
									<>
										{dataPeriodo && dataPeriodo.slice(0, 6).map((skill) => (
											<Accordion key={skill.periodo_id} style={{ boxShadow: 'none', marginBottom: '8px' }}>
												<AccordionSummary className={className} style={{ backgroundColor: '#F7F8FC', justifyContent: 'center', alignItems: 'center' }}>
													<div style={{ flexWrap: 'wrap', paddingLeft: '30px' }}>
														<h2
															style={{
																marginLeft: '20px',
																fontSize: '14px',
																fontFamily: 'Public Sans',
																fontWeight: '500',
																color: '#4A4F58',

															}}
														>
															{skill.periodo_nome}
														</h2>
													</div>

													<p
														style={{
															marginLeft: 'auto',
															fontSize: '16px',
															fontFamily: 'Public Sans',
															fontWeight: '600',
															color: '#727780'
														}}
													>
														{skill.quantidade_usos}
													</p>
													<IconButton style={{ position: 'relative', right: '97%' }}>
														<ExpandMoreIcon />
													</IconButton>
												</AccordionSummary>

												<AccordionDetails>
													<ul style={{ width: '100%' }} >
														{Object.entries(skill.escolas_utilizaram).map(([escola, vezes]) => (
															<li
																key={escola}
																style={{
																	display: 'flex',
																	justifyContent: 'space-between',
																	alignItems: 'center',
																	color: '#727780',
																	fontFamily: 'Public Sans',
																	fontWeight: '400',
																	fontSize: '16px',
																	borderBottom: '1px solid #ccc',
																	padding: '8px 0',
																	width: '100%'
																}}
															>
																<span style={{ flex: 1, fontFamily: 'Public Sans' }}>{escola}</span>
																<span style={{ flex: 1, textAlign: 'right', fontFamily: 'Public Sans' }}>{vezes}</span>
															</li>
														))}

													</ul>
												</AccordionDetails>
											</Accordion>
										))}
									</>
								) : (
									<Loading/>
								)}
							</div>
						)}
						{/* {selectedTab === 'componente curricular' && (
							<div>
								<Grid item xs={12} style={{ borderBottom: '2px solid #E5E7EB' }}>
									<p
										style={{
											fontSize: '16px',
											fontFamily: 'Public Sans',
											color: '#727780',
											fontWeight: '600',
											padding: '8px',
											marginBottom: '6px'

										}}
									>
										Componente curricular
									</p>
								</Grid>

								<div>
									<Grid item xs={12} style={{ borderRadius: '10px', marginBottom: '12px', }}>
										<Grid container alignItems="center">
											<Grid item xs={12}>
												<div
													style={{
														display: 'flex',
														alignItems: 'center',

													}}
												>
													<StyledTextField
														style={{ width: '100%' }}
														label="Pesquisar componente curricular"
														variant="outlined"
														onChange={(e) => handleSetStateComponente(e.target.value)}
														InputProps={{
															startAdornment: (
																<InputAdornment position="start">
																	<SvgIcon
																		width="24"
																		height="24"
																		viewBox="0 0 24 24"
																		fill="none"
																		xmlns="http://www.w3.org/2000/svg"
																		style={{ cursor: 'pointer' }}
																	>
																		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<g clip-path="url(#clip0_695_46806)">
																				<path d="M10.9922 19.9922C9.75781 19.9922 8.59375 19.7578 7.5 19.2891C6.40625 18.8203 5.45312 18.1797 4.64062 17.3672C3.82812 16.5547 3.1875 15.6016 2.71875 14.5078C2.23438 13.4141 1.99219 12.2422 1.99219 10.9922C1.99219 9.75781 2.23438 8.59375 2.71875 7.5C3.1875 6.40625 3.82812 5.45312 4.64062 4.64062C5.45312 3.82813 6.40625 3.1875 7.5 2.71875C8.59375 2.23438 9.75781 1.99219 10.9922 1.99219C12.2422 1.99219 13.4141 2.23438 14.5078 2.71875C15.6016 3.1875 16.5547 3.82813 17.3672 4.64062C18.1797 5.45312 18.8203 6.40625 19.2891 7.5C19.7578 8.59375 19.9922 9.75781 19.9922 10.9922C19.9922 11.9141 19.8594 12.8047 19.5938 13.6641C19.3281 14.5078 18.9609 15.2812 18.4922 15.9844L21.4922 19.0078C21.8359 19.3516 22.0078 19.7656 22.0078 20.25C22.0078 20.7344 21.8359 21.1484 21.4922 21.4922C21.1484 21.8359 20.7344 22.0078 20.25 22.0078C19.7656 22.0078 19.3516 21.8359 19.0078 21.4922L15.9844 18.4922C15.2812 18.9609 14.5 19.3281 13.6406 19.5938C12.7969 19.8594 11.9141 19.9922 10.9922 19.9922ZM10.9922 18C11.9609 18 12.875 17.8203 13.7344 17.4609C14.5781 17.0859 15.3125 16.5859 15.9375 15.9609C16.5781 15.3203 17.0859 14.5781 17.4609 13.7344C17.8203 12.875 18 11.9609 18 10.9922C18 10.0234 17.8203 9.11719 17.4609 8.27344C17.0859 7.42969 16.5781 6.69531 15.9375 6.07031C15.3125 5.42969 14.5781 4.92188 13.7344 4.54688C12.875 4.1875 11.9609 4.00781 10.9922 4.00781C10.0234 4.00781 9.11719 4.1875 8.27344 4.54688C7.42969 4.92188 6.6875 5.42969 6.04688 6.07031C5.42188 6.69531 4.92188 7.42969 4.54688 8.27344C4.1875 9.11719 4.00781 10.0234 4.00781 10.9922C4.00781 11.9609 4.1875 12.875 4.54688 13.7344C4.92188 14.5781 5.42188 15.3203 6.04688 15.9609C6.6875 16.5859 7.42969 17.0859 8.27344 17.4609C9.11719 17.8203 10.0234 18 10.9922 18ZM10.9922 6C10.7266 6 10.4922 6.10156 10.2891 6.30469C10.1016 6.49219 10.0078 6.72656 10.0078 7.00781C10.0078 7.27344 10.1016 7.50781 10.2891 7.71094C10.4922 7.89844 10.7266 7.99219 10.9922 7.99219C11.8203 7.99219 12.5234 8.28906 13.1016 8.88281C13.6953 9.46094 13.9922 10.1641 13.9922 10.9922C13.9922 11.2734 14.0859 11.5156 14.2734 11.7188C14.4766 11.9062 14.7188 12 15 12C15.2812 12 15.5156 11.9062 15.7031 11.7188C15.9062 11.5156 16.0078 11.2734 16.0078 10.9922C16.0078 10.3047 15.875 9.65625 15.6094 9.04688C15.3438 8.4375 14.9844 7.91406 14.5312 7.47656C14.0781 7.02344 13.5469 6.66406 12.9375 6.39844C12.3438 6.13281 11.6953 6 10.9922 6Z" fill="#ABB0BA" />
																			</g>
																			<defs>
																				<clipPath id="clip0_695_46806">
																					<rect width="24" height="24" fill="white" />
																				</clipPath>
																			</defs>
																		</svg>

																	</SvgIcon>
																</InputAdornment>
															),
														}}
													/>
												</div>
											</Grid>
										</Grid>
									</Grid>
								</div>

								{dataComponente && dataComponente.slice(0, 6).map((skill) => (
									<Accordion key={skill.componente_curricular_id} style={{ boxShadow: 'none', marginBottom: '8px' }}>
										<AccordionSummary className={className} style={{ backgroundColor: '#F7F8FC' }}>
											<div style={{ flexWrap: 'wrap', paddingLeft: '30px' }}>
												<h2
													style={{
														marginLeft: '20px',
														fontSize: '14px',
														fontFamily: 'Public Sans',
														fontWeight: '500',
														color: '#4A4F58'
													}}
												>
													{typeof skill.area_conhecimento === 'string' ? `${skill.area_conhecimento} - ` : ''}{skill.componente_curricular_nome}
												</h2>
											</div>
											<p
												style={{
													marginLeft: 'auto',
													fontSize: '16px',
													fontFamily: 'Public Sans',
													fontWeight: '600',
													color: '#727780'
												}}
											>
												{skill.quantidade_usos}
											</p> */}

											{/* <IconButton style={{ position: 'relative', right: '97%' }}>
												<ExpandMoreIcon />
											</IconButton> */}
										{/* </AccordionSummary> */}

										{/* <AccordionDetails>
											<ul style={{ width: '100%' }} >
												{Object.entries(skill.escolas_utilizaram).map(([escola, vezes]) => (
													<li
														key={escola}
														style={{
															display: 'flex',
															justifyContent: 'space-between',
															alignItems: 'center',
															color: '#727780',
															fontFamily: 'Public Sans',
															fontWeight: '400',
															fontSize: '16px',
															borderBottom: '1px solid #ccc',
															padding: '8px 0',
															width: '100%'
														}}
													>
														<span style={{ flex: 1, fontFamily: 'Public Sans' }}>{escola}</span>
														<span style={{ flex: 1, textAlign: 'right', fontFamily: 'Public Sans' }}>{vezes}</span>
													</li>
												))}
											</ul>
										</AccordionDetails> */}
									{/* </Accordion>
								))}
							</div>
						)} */}
						{selectedTab === 'metodologia' && (
							<div>
								<Grid item xs={12} style={{ borderBottom: '2px solid #E5E7EB' }}>
									<p
										style={{
											fontSize: '16px',
											fontFamily: 'Public Sans',
											color: '#727780',
											fontWeight: '600',
											padding: '8px',
											marginBottom: '6px'
										}}
									>
										Metodologia de Ensino
									</p>
								</Grid>

								<div>
									<Grid item xs={12} style={{ borderRadius: '10px', marginBottom: '12px', }}>
										<Grid container alignItems="center">
											<Grid item xs={12}>
												<div
													style={{
														display: 'flex',
														alignItems: 'flex-start',
														flexDirection: 'column',
													}}
												>
													{/* <StyledTextField
														style={{ width: '100%' }}
														label="Pesquisar metodologia"
														variant="outlined"
														onChange={(e) => handleSetStateMetodologia(e.target.value)}
														InputProps={{
															startAdornment: (
																<InputAdornment position="start">
																	<SvgIcon
																		width="24"
																		height="24"
																		viewBox="0 0 24 24"
																		fill="none"
																		xmlns="http://www.w3.org/2000/svg"
																		style={{ cursor: 'pointer' }}
																	>
																		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<g clip-path="url(#clip0_695_46806)">
																				<path d="M10.9922 19.9922C9.75781 19.9922 8.59375 19.7578 7.5 19.2891C6.40625 18.8203 5.45312 18.1797 4.64062 17.3672C3.82812 16.5547 3.1875 15.6016 2.71875 14.5078C2.23438 13.4141 1.99219 12.2422 1.99219 10.9922C1.99219 9.75781 2.23438 8.59375 2.71875 7.5C3.1875 6.40625 3.82812 5.45312 4.64062 4.64062C5.45312 3.82813 6.40625 3.1875 7.5 2.71875C8.59375 2.23438 9.75781 1.99219 10.9922 1.99219C12.2422 1.99219 13.4141 2.23438 14.5078 2.71875C15.6016 3.1875 16.5547 3.82813 17.3672 4.64062C18.1797 5.45312 18.8203 6.40625 19.2891 7.5C19.7578 8.59375 19.9922 9.75781 19.9922 10.9922C19.9922 11.9141 19.8594 12.8047 19.5938 13.6641C19.3281 14.5078 18.9609 15.2812 18.4922 15.9844L21.4922 19.0078C21.8359 19.3516 22.0078 19.7656 22.0078 20.25C22.0078 20.7344 21.8359 21.1484 21.4922 21.4922C21.1484 21.8359 20.7344 22.0078 20.25 22.0078C19.7656 22.0078 19.3516 21.8359 19.0078 21.4922L15.9844 18.4922C15.2812 18.9609 14.5 19.3281 13.6406 19.5938C12.7969 19.8594 11.9141 19.9922 10.9922 19.9922ZM10.9922 18C11.9609 18 12.875 17.8203 13.7344 17.4609C14.5781 17.0859 15.3125 16.5859 15.9375 15.9609C16.5781 15.3203 17.0859 14.5781 17.4609 13.7344C17.8203 12.875 18 11.9609 18 10.9922C18 10.0234 17.8203 9.11719 17.4609 8.27344C17.0859 7.42969 16.5781 6.69531 15.9375 6.07031C15.3125 5.42969 14.5781 4.92188 13.7344 4.54688C12.875 4.1875 11.9609 4.00781 10.9922 4.00781C10.0234 4.00781 9.11719 4.1875 8.27344 4.54688C7.42969 4.92188 6.6875 5.42969 6.04688 6.07031C5.42188 6.69531 4.92188 7.42969 4.54688 8.27344C4.1875 9.11719 4.00781 10.0234 4.00781 10.9922C4.00781 11.9609 4.1875 12.875 4.54688 13.7344C4.92188 14.5781 5.42188 15.3203 6.04688 15.9609C6.6875 16.5859 7.42969 17.0859 8.27344 17.4609C9.11719 17.8203 10.0234 18 10.9922 18ZM10.9922 6C10.7266 6 10.4922 6.10156 10.2891 6.30469C10.1016 6.49219 10.0078 6.72656 10.0078 7.00781C10.0078 7.27344 10.1016 7.50781 10.2891 7.71094C10.4922 7.89844 10.7266 7.99219 10.9922 7.99219C11.8203 7.99219 12.5234 8.28906 13.1016 8.88281C13.6953 9.46094 13.9922 10.1641 13.9922 10.9922C13.9922 11.2734 14.0859 11.5156 14.2734 11.7188C14.4766 11.9062 14.7188 12 15 12C15.2812 12 15.5156 11.9062 15.7031 11.7188C15.9062 11.5156 16.0078 11.2734 16.0078 10.9922C16.0078 10.3047 15.875 9.65625 15.6094 9.04688C15.3438 8.4375 14.9844 7.91406 14.5312 7.47656C14.0781 7.02344 13.5469 6.66406 12.9375 6.39844C12.3438 6.13281 11.6953 6 10.9922 6Z" fill="#ABB0BA" />
																			</g>
																			<defs>
																				<clipPath id="clip0_695_46806">
																					<rect width="24" height="24" fill="white" />
																				</clipPath>
																			</defs>
																		</svg>

																	</SvgIcon>
																</InputAdornment>
															),
														}}
													/> */}
													Pesquisar metodologia:
													<input
														onChange={
															(e) => handleSetStateMetodologia(e.target.value.toUpperCase())
														}
														style={{ width: '100%' }}
														type='text'
													/>
												</div>
											</Grid>
										</Grid>
									</Grid>
								</div>
								{!isLoading ? (
									<>
										{dataMetodologia && dataMetodologia.slice(0, 6).map((skill) => (
											<Accordion key={skill.metodologia_id} style={{ boxShadow: 'none', marginBottom: '8px' }}>
												<AccordionSummary className={className} style={{ backgroundColor: '#F7F8FC' }}>
													<div style={{ flexWrap: 'wrap', paddingLeft: '30px' }}>
														<h2
															style={{
																marginLeft: '20px',
																fontSize: '14px',
																fontFamily: 'Public Sans',
																fontWeight: '500',
																color: '#4A4F58'
															}}
														>
															{skill.metodologia_nome}
														</h2>
													</div>

													<p
														style={{
															marginLeft: 'auto',
															fontSize: '16px',
															fontFamily: 'Public Sans',
															fontWeight: '600',
															color: '#727780'
														}}
													>
														{skill.quantidade_usos}
													</p>

													<IconButton style={{ position: 'relative', right: '97%' }}>
														<ExpandMoreIcon />
													</IconButton>
												</AccordionSummary>

												<AccordionDetails>
													<ul style={{ listStyle: 'none', padding: 0, width: '100%' }}>
														{Object.entries(skill.escolas_utilizaram).map(([escola, vezes]) => (
															<li
																key={escola}
																style={{
																	display: 'flex',
																	justifyContent: 'space-between',
																	alignItems: 'center',
																	color: '#727780',
																	fontFamily: 'Public Sans',
																	fontWeight: '400',
																	fontSize: '16px',
																	borderBottom: '1px solid #ccc',
																	padding: '8px 0',
																	width: '100%'
																}}
															>
																<span style={{ flex: 1, fontFamily: 'Public Sans' }}>{escola}</span>
																<span style={{ flex: 1, textAlign: 'right', fontFamily: 'Public Sans' }}>{vezes}</span>
															</li>
														))}
													</ul>
												</AccordionDetails>
											</Accordion>
										))}
									</>
								) : (
									<Loading/>
								)}
							</div>
						)}
					</Grid>
				</Grid>
			</Grid>
		</div>
	);
};

export default SkillsList;
